/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Drawer from '@material-ui/core/Drawer';
import globals from '../../../globals/communityGlobals';

const locale = globals.getArea('header');
const altText = locale.getMsg('applicationLogo');
const { basename } = globals.urls;
const imageSource = `${basename}images/branding/Allocate-Solutions-ECommunity.png`;
const logOutText = locale.getMsg('logout');

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

export default function CommunityAppBar() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [showQuickMenu, setShowQuickMenu] = React.useState(false);

  const handleQuickMenu = () => {
    setShowQuickMenu(false);
  };

  return (
    <React.Fragment>
      <AppBar position="static">
        <Toolbar>
          <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
            <MenuIcon />
          </IconButton>
          <div className="logo-area">
            <img alt={altText} src={imageSource} />
          </div>
          <div>
            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={event => setAnchorEl(event.currentTarget)}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={open}
              onClose={() => setAnchorEl(null)}
            >
              <MenuItem onClick={() => setAnchorEl(null)}>{logOutText}</MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      <Drawer open={showQuickMenu}>
        <MenuItem onClick={handleQuickMenu}>Menu Item 1</MenuItem>
        <MenuItem onClick={handleQuickMenu}>Menu Item 2</MenuItem>
      </Drawer>
    </React.Fragment>
  );
}
